import { render } from "./CrearAdmin.vue?vue&type=template&id=e5a81946"
import script from "./CrearAdmin.vue?vue&type=script&lang=js"
export * from "./CrearAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__